import React, { useEffect, useState } from 'react';
import styles from './FinishingElement.module.css';
import localeRu from '../../../../locales/ru/stations/stationControl.json';
import localeEn from '../../../../locales/en/stations/stationControl.json';
import phaseA from "../../../../img/phaseA.svg";
import phaseB from "../../../../img/phaseB.svg";
import phaseC from "../../../../img/phaseC.svg";
import consumedEnergyIcon from "../../../../img/batteryMini.svg";
import timeIcon from "../../../../img/clockMini.svg";
import carStatusOn from "../../../../img/carStatusOn.svg";

const FinishingElement = ({ connector }) => {
    let lang = localStorage.getItem('language') === 'ru';

    const formatTime = (seconds) => {
        if (seconds == null) {
            return "00:00";
        }
        const hours = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
    };

    const formatAmperege = (amperage) => {
        if (!amperage) {
            return "0.0";
        }
        const parseAmpere = (amperage * 1).toFixed(1);
        return parseAmpere;
    };

    const formatPower = (power) => {
        if (!power) {
            return "0.0";
        }
        const parsePower = (power / 100).toFixed(1);
        return parsePower;
    };


    return (
        <div className={styles.parameters}>
            <p className={styles.titleText}>{lang ? localeRu.charging_finished : localeEn.charging_finished}</p>
            <div className={styles.blocks}>
                {/* Colomn 1 */}
                <div className={styles.paramContainer}>
                    <div className={styles.firstSection}>
                        <div className={styles.iconContainer}>
                            <img src={timeIcon} className={styles.paramImage} alt='phase A' />
                        </div>
                        <p className={styles.paramText}>{lang ? localeRu.charging_time : localeEn.charging_time}</p>
                    </div>
                    <p className={styles.paramText}>{formatTime(connector?.chargingTime)} </p>
                </div>
                {/* Colomn 2 */}
                <div className={styles.paramContainer}>
                    <div className={styles.firstSection}>
                        <div className={styles.iconContainer}>
                            <img src={consumedEnergyIcon} className={styles.paramImage} alt='phase B' />
                        </div>
                        <p className={styles.paramText}>{lang ? localeRu.consumption : "Phase"}</p>
                    </div>
                    <p className={styles.paramText}>{formatPower(connector?.consumedEnergy)}
                        <span className={styles.unitGray}> {lang ? "кBтч" : "kWh"} </span> </p>
                </div>
                {/* Colomn 3 */}
                <div className={styles.paramContainer}>
                    <div className={styles.firstSection}>
                        <div className={styles.iconContainer}>
                            <img src={carStatusOn} className={styles.paramImage} alt='phase C' />
                        </div>
                        <p className={styles.paramText}>{lang ? localeRu.range : localeEn.range}</p>
                    </div>
                    <p className={styles.paramText}>
                        <span className={styles.unitGray}>~ </span>
                        {((Math.round(formatPower(connector?.consumedEnergy)) / 22) * 100).toFixed(1)} 
                        <span className={styles.unitGray}> {lang ? "км" : "km"} </span> </p>
                </div>
            </div>
        </div>
    )
}

export default FinishingElement;